import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Skeleton } from "@/components/Primitives";
import { Users, Mail, UserPlus, Clock, FolderOpen, Share2, Archive, ShieldAlert } from "lucide-react";

const CARDS = [
  ["active_staff", "Active Staff", Users, "#00C9E0"],
  ["pending_invites", "Pending Invitations", Mail, "#F59E0B"],
  ["unassigned_leads", "Unassigned Leads", UserPlus, "#A78BFA"],
  ["overdue_followups", "Overdue Follow-Ups", Clock, "#FE421C"],
  ["documents", "Documents", FolderOpen, "#9ACC32"],
  ["recent_shares", "Shared (7d)", Share2, "#38BDF8"],
  ["trashed", "In Trash", Archive, "#64748B"],
  ["security_issues", "Security Alerts", ShieldAlert, "#FE3967"],
];

export default function AdminSnapshot() {
  const navigate = useNavigate();
  const [snap, setSnap] = useState(null);
  useEffect(() => { api.get("/admin/snapshot").then((r) => setSnap(r.data)).catch(() => {}); }, []);

  if (!snap) return <div className="grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-8 gap-3 mb-6">{[...Array(8)].map((_, i) => <Skeleton key={i} className="h-20" />)}</div>;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-8 gap-3 mb-6" data-testid="admin-snapshot">
      {CARDS.map(([key, label, Icon, color]) => {
        const c = snap[key] || { value: 0, link: "/admin" };
        const alert = (key === "overdue_followups" || key === "security_issues" || key === "unassigned_leads") && c.value > 0;
        return (
          <button key={key} onClick={() => navigate(c.link)} data-testid={`snap-${key}`}
            className="cc-card p-3.5 text-left hover:border-[#00C9E0]/50 hover:shadow-sm transition">
            <div className="flex items-center justify-between">
              <span className="h-7 w-7 rounded-lg flex items-center justify-center" style={{ background: `${color}1f` }}><Icon className="h-4 w-4" style={{ color }} /></span>
              {alert && <span className="h-2 w-2 rounded-full bg-[#FE421C]" />}
            </div>
            <p className="mt-2 font-display text-xl font-bold text-[#1E2025] tnum">{c.value}</p>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400 leading-tight">{label}</p>
          </button>
        );
      })}
    </div>
  );
}
